import { BioCardGrid } from '@ahc-digital/component-library';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { GetBiographyGridModel } from './C56BiographyGrid.service';
import { C56BiographyGridProps } from './C56BiographyGrid.types';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export const Default = (props?: C56BiographyGridProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  return <BioCardGrid data-component={marketingRenderingName} {...GetBiographyGridModel(props)} />;
};
